import {
  as_text,
  get_form_type_name_from,
  is_document_type_name,
  parse_response_payload,
  to_positive_id
} from './bind_documents_helpers';

export default {
  selected_forms_summary_label() {
    return `${this.selected_form_count} form${this.selected_form_count === 1 ? '' : 's'} selected`;
  },
  parse_response_data(payload) {
    return parse_response_payload(payload);
  },
  get_form_type_name(form) {
    return get_form_type_name_from(form);
  },
  is_document_form(form) {
    return is_document_type_name(this.get_form_type_name(form));
  },
  normalize_form(form) {
    return Object.assign({}, form, this.get_normalized_form_fields(form));
  },
  get_normalized_form_fields(form) {
    return Object.assign({}, {
      id: to_positive_id(form?.id || form?.form_id),
      form_name: as_text(form?.form_name || form?.name, 'Document Form'),
      form_description: as_text(form?.form_description || form?.description),
      form_type_name: this.get_form_type_name(form),
    });
  },
  normalize_form_binding(binding) {
    const form_id = to_positive_id(binding?.form || binding?.form_id);
    const source_form = this.get_source_form(form_id);
    return Object.assign({}, binding, {
      id: to_positive_id(binding?.id),
      form: form_id,
      form_name: this.get_binding_form_name(binding, source_form),
      form_description: this.get_binding_form_description(binding, source_form),
      form_type_name: this.get_binding_form_type_name(binding, source_form),
      priority: Number(binding?.priority || 0) || 0,
    });
  },
  get_source_form(form_id) {
    if (!form_id) return null;
    return this.available_forms_by_id.get(form_id);
  },
  get_binding_form_name(binding, source_form) {
    return as_text(binding?.form_name || source_form?.form_name || binding?.name, 'Document Form');
  },
  get_binding_form_description(binding, source_form) {
    return as_text(binding?.form_description || source_form?.form_description || binding?.description);
  },
  get_binding_form_type_name(binding, source_form) {
    return this.get_form_type_name(binding) || source_form?.form_type_name || '';
  },
  is_document_form_binding(binding) {
    if (this.is_document_form(binding)) return true;
    return this.has_available_form(binding?.form || binding?.form_id);
  },
  has_available_form(form_id) {
    const normalized_form_id = to_positive_id(form_id);
    return normalized_form_id ? this.available_forms_by_id.has(normalized_form_id) : false;
  },
  describe_binding(binding) {
    return binding?.form_description || 'Captures document uploads and supporting files for this entity.';
  },
  extract_form_bindings(parsed) {
    return Array.isArray(parsed?.data?.form_bindings) ? parsed.data.form_bindings : [];
  }
};
